import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { BaseModule } from "../base-module/base.module";
import { NotificacaoRoutesModule } from './notificacao.routing';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FiltroNotificacaoComponent } from './filtro-notificacao/filtro-notificacao.component';
import { ListaNotificacaoComponent } from './lista-notificacao/lista-notificacao.component';
import { VerNotificacaoComponent } from './ver-notificacao/ver-notificacao.component';

@NgModule({  
  imports: [
    CommonModule,
    NotificacaoRoutesModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatGridListModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatListModule,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatTabsModule,
    MatRadioModule, 
    MatMenuModule, 
    MatChipsModule, 
    MatExpansionModule, 
    MatFormFieldModule, 
    MatRippleModule, 
    MatSortModule, 
    MatTableModule,
    FormsModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FlexLayoutModule,
    BaseModule,
    CurrencyMaskModule,
    MatBadgeModule
  ],
  declarations: [
    ListaNotificacaoComponent,
    VerNotificacaoComponent,
    FiltroNotificacaoComponent
  ],
  providers: [
    
  ],
  // entryComponents:[
  //   VerNotificacaoComponent,
  //   FiltroNotificacaoComponent
  // ]
})
export class NotificacaoModule { }
